import PropTypes from 'prop-types';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import DescriptionIcon from '@mui/icons-material/DescriptionOutlined';
import TokenIcon from '@mui/icons-material/GeneratingTokensOutlined';
import TimerIcon from '@mui/icons-material/TimerOutlined';
import AttachMoneyIcon from '@mui/icons-material/AttachMoneyOutlined';

const StatCard = styled(Paper)(({ theme }) => ({
  backgroundColor: '#ffffff',
  borderRadius: '16px',
  padding: theme.spacing(2.5),
  boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 0 rgba(0, 0, 0, 0.03)',
  border: '1px solid #e2e8f0',
  transition: 'all 0.2s ease-in-out',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  position: 'relative',
  overflow: 'hidden',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -2px rgba(0, 0, 0, 0.04)',
    borderColor: '#cbd5e1',
  },
}));

const IconWrapper = styled(Box)(({ color }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 44,
  height: 44,
  borderRadius: '12px',
  backgroundColor: color.bg,
  color: color.text,
}));

const theme = createTheme({ palette: { mode: 'light' } });

const TopCards = ({ data }) => {
  const cardsList = data?.items || [
    {
      title: 'Proposals Generated',
      value: data?.total_proposals || '0',
      icon: <DescriptionIcon fontSize="medium" />,
      color: { bg: '#eff6ff', text: '#2563eb' },
    },
    {
      title: 'Total tokens used',
      value: data?.total_tokens || '0',
      icon: <TokenIcon fontSize="medium" />,
      color: { bg: '#f0fdf4', text: '#16a34a' },
    },
    {
      title: 'Avg proposal generation time (Sec)',
      value: data?.avg_latency || '0',
      icon: <TimerIcon fontSize="medium" />,
      color: { bg: '#fef3c7', text: '#d97706' },
    },
    {
      title: 'Total Cost',
      value: data?.total_cost || '0',
      icon: <AttachMoneyIcon fontSize="medium" />,
      color: { bg: '#fae8ff', text: '#c026d3' },
    },
  ];

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            sm: 'repeat(2, 1fr)',
            md: 'repeat(4, 1fr)',
          },
          gap: 3,
          width: '100%',
          my: 3,
        }}
      >
        {cardsList.map((card, index) => (
          <StatCard key={index} elevation={0}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
              <Typography
                variant="body2"
                sx={{
                  color: '#64748b',
                  fontWeight: 600,
                  fontSize: '0.85rem',
                  letterSpacing: '0.01em',
                }}
              >
                {card.title}
              </Typography>
              <IconWrapper color={card.color}>{card.icon}</IconWrapper>
            </Box>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                color: '#0f172a',
                letterSpacing: '-0.02em',
                fontSize: '1.75rem',
              }}
            >
              {card.value}
            </Typography>
          </StatCard>
        ))}
      </Box>
    </ThemeProvider>
  );
};

TopCards.propTypes = {
  data: PropTypes.object,
};

export default TopCards;